import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import NavBar from "../../Components/interface/NavBar";
import styles from "./InspectionReport.module.css";
import CustomerScans from "../../utils/api/CustomerScans";
import image4 from "../../asset/images/car.png";
import ServiceApi from "../../utils/api/ServiceApi";
import { useSelector } from "react-redux";
import VehicleInformation2 from "../../Components/UI/VehicleInformation2";
import BottomNav from "../../Components/BottomNav";

function InspectionSingleReport(props) {
  const [data, setData] = useState([]);
  const [showReport, setShowReport] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [carImage, setCarImage] = useState([]);

  const dongle = useSelector((data) => data.dongles);

  const personalData = useSelector((data) => data.auth);

  const openInfoHandler = (index) => {
    if (currentIndex === index) {
      setShowReport(false);
      setCurrentIndex(null);
    } else {
      setShowReport(true);
    }
  };

  const vehicle_data =
    personalData?.generalLoginData?.vehicle_data?.length !== 0
      ? personalData?.generalLoginData?.vehicle_data
      : personalData?.generalLoginData?.vendor_vehicle_data;

  useEffect(() => {
    const fetchVehicleImages = async () => {
      try {
        const imageRes = await ServiceApi.fetchVehicles();
        const vehicleImage = imageRes.data.find(
          (data) =>
            data.year === vehicle_data[dongle?.currentVehicle]?.vehicle_year &&
            data.model?.toUpperCase() ===
              vehicle_data[
                dongle?.currentVehicle
              ]?.vehicle_model?.toUpperCase() &&
            data.make?.toUpperCase() ===
              vehicle_data[dongle?.currentVehicle]?.vehicle_make?.toUpperCase()
        );
        setCarImage(vehicleImage);
      } catch (err) {
        console.log(err);
      }
    };
    fetchVehicleImages();
  }, [dongle?.currentVehicle, vehicle_data]);

  const { id } = useParams();

  useEffect(() => {
    const fetchInspectionReport = async () => {
      try {
        const inspectionDetailsRes = await CustomerScans.getInspeactionReport({
          inspection_id: id,
        });
        setData(inspectionDetailsRes.data);
      } catch (err) {
        console.log(err?.response?.data);
      }
    };
    fetchInspectionReport();
  }, [id]);

  return (
    <section className={styles.buyDongle}>
      <NavBar title="Inspection" setShowMenu={props.setShowMenu} />
      <div className={styles.head}>
        <div className={styles.main_hero}>
          <div className={styles.history}>
            <div className={styles.carType}>
              <div className={styles.buyDongle__wrapper}>
                <img src={carImage?.imageUrl || image4} alt="car" />
              </div>
            </div>
          </div>
          <div className={styles.vehicleInfo}>
            <VehicleInformation2
              vehicle_make={vehicle_data[dongle.currentVehicle]?.vehicle_make}
              vehicle_model={vehicle_data[dongle.currentVehicle]?.vehicle_model}
              vehicle_year={vehicle_data[dongle.currentVehicle]?.vehicle_year}
              vin="Not Available"
              vehicle_engine={false}
              inspection_number={id}
              inspection_date={data?.report?.created_at.slice(0, 10)}
              plate_number={
                personalData.generalLoginData[0]?.vehicle_data[
                  dongle.currentVehicle
                ]?.plate_number
              }
            />
          </div>

          <div className={styles.papers_head}>
            <div>
              <p>Condition</p>
            </div>
            <div>
              <div>
                <svg
                  width="12"
                  height="13"
                  viewBox="0 0 12 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="6" cy="6.5" r="6" fill="#0AB34E" />
                </svg>
                <p>Good</p>
              </div>

              <div>
                <svg
                  width="12"
                  height="13"
                  viewBox="0 0 12 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="6" cy="6.5" r="6" fill="#FFB200" />
                </svg>

                <p>Fair</p>
              </div>

              <div>
                <svg
                  width="12"
                  height="13"
                  viewBox="0 0 12 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="6" cy="6.5" r="6" fill="#FD4D1E" />
                </svg>

                <p>Priortize</p>
              </div>
            </div>
          </div>

          <div className={styles.inspection_report_list}>
            {data?.inspections?.map((data, index) => (
              <div>
                {data?.details.length > 0 && (
                  <div
                    key={data?.category_name}
                    className={styles.body}
                    onClick={() => {
                      setCurrentIndex(index);
                      openInfoHandler(index);
                    }}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.773 3.48534L13.993 3.30134L11.885 5.39734L10.691 4.18134L12.747 2.02434L12.567 1.23234C12.1326 1.08699 11.6781 1.01007 11.22 1.00434C10.7203 0.996652 10.2243 1.09196 9.76303 1.28434C9.31763 1.48595 8.91503 1.7711 8.57703 2.12434C8.20078 2.48075 7.9028 2.91154 7.70203 3.38934C7.31548 4.34022 7.31548 5.40445 7.70203 6.35534C5.61727 8.40633 3.55942 10.4845 1.52903 12.5893C1.31903 12.8643 1.21903 13.2073 1.24503 13.5523C1.26552 13.9234 1.43239 14.2712 1.70903 14.5193C1.83303 14.6543 1.98103 14.7663 2.14603 14.8473C2.31603 14.9223 2.49903 14.9653 2.68403 14.9743C3.00003 14.9683 3.30303 14.8483 3.53803 14.6373C5.08603 13.1803 8.05203 10.1873 9.73703 8.43334C10.194 8.62734 10.685 8.72734 11.181 8.72634C11.6803 8.72594 12.1744 8.62548 12.6342 8.43088C13.094 8.23628 13.5102 7.95149 13.858 7.59334C14.5726 6.8646 14.9717 5.88394 14.969 4.86334C14.9806 4.39631 14.9143 3.93062 14.773 3.48534V3.48534ZM2.93303 13.9283C2.89454 13.9625 2.84814 13.9866 2.79803 13.9983C2.74873 14.0069 2.69833 14.0069 2.64903 13.9983C2.59734 13.9905 2.5481 13.971 2.50503 13.9413C2.4588 13.9143 2.41972 13.8766 2.39103 13.8313C2.25103 13.6883 2.12003 13.4163 2.25103 13.2633C3.62103 11.8063 6.44203 8.95834 8.20603 7.21734C8.30603 7.34934 8.41603 7.47534 8.53403 7.59334C8.65203 7.71634 8.77903 7.83034 8.91403 7.93434C7.20803 9.68434 4.42603 12.4983 2.93403 13.9283H2.93303ZM14.051 4.86334C14.053 5.62834 13.755 6.36334 13.219 6.91134C12.6842 7.43603 11.9648 7.72996 11.2155 7.72996C10.4663 7.72996 9.7469 7.43603 9.21203 6.91134C8.82001 6.50223 8.55222 5.99023 8.43981 5.43488C8.32739 4.87954 8.37498 4.30369 8.57703 3.77434C8.71152 3.41407 8.92013 3.08604 9.18937 2.81147C9.4586 2.53689 9.78247 2.32188 10.14 2.18034C10.4795 2.03824 10.844 1.96548 11.212 1.96634H11.466L9.64903 3.83934V4.53534L11.544 6.42134H12.204L14.051 4.60534V4.86334V4.86334ZM3.24003 6.68834H4.77103L5.47603 7.40534L6.15403 6.73134L5.48903 6.05334V6.01034L5.54603 4.36134L5.32603 3.92434L2.46603 2.04234L1.87503 2.10834L1.04403 2.95734L0.978027 3.55634L2.81603 6.47434L3.24003 6.68934V6.68834ZM2.29503 3.05634L4.60903 4.58034L4.57003 5.70334H3.49403L2.00203 3.34134L2.29503 3.05634V3.05634ZM9.40003 10.0163L10.074 9.34334L13.18 12.5283C13.4416 12.8033 13.5876 13.1683 13.5876 13.5478C13.5876 13.9274 13.4416 14.2924 13.18 14.5673C12.9833 14.7693 12.7303 14.9074 12.4541 14.9635C12.1778 15.0197 11.891 14.9914 11.631 14.8823C11.4651 14.8087 11.3163 14.7015 11.194 14.5673L8.05203 11.3643L8.73103 10.6863L11.863 13.8803C11.9051 13.9268 11.9575 13.9627 12.016 13.9853C12.1311 14.0321 12.2599 14.0321 12.375 13.9853C12.4335 13.9627 12.4859 13.9268 12.528 13.8803C12.5718 13.837 12.6059 13.7848 12.628 13.7273C12.651 13.6687 12.6632 13.6063 12.664 13.5433C12.663 13.4804 12.6512 13.4182 12.629 13.3593C12.6069 13.3018 12.5728 13.2497 12.529 13.2063L9.40003 10.0163Z"
                        fill="#03C962"
                      />
                    </svg>

                    <p>{data?.category_name}</p>

                    {showReport && index === currentIndex ? (
                      <svg
                        width="29"
                        height="28"
                        viewBox="0 0 29 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20.5 17L14.5 11L8.5 17"
                          stroke="#151522"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    ) : (
                      <svg
                        width="29"
                        height="28"
                        viewBox="0 0 29 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20.5 11L14.5 17L8.5 11"
                          stroke="#151522"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    )}
                  </div>
                )}
                {showReport && index === currentIndex && (
                  <div className={styles.vehicleDetails_2}>
                    <div className={styles.vehicleDetails_2_head}>
                      <p>{data?.category_name} Inspection</p>
                    </div>
                    <div className={styles.vehicleDetails_2_inner}>
                      {/* <div></div>{" "} */}
                      <div className={styles.vehicleDetails_2_inner_wrapper}>
                        {data?.details.map((details) => (
                          <div className={styles.vehicleDetails_2_inner_items}>
                            <p>{details.sub_category_name}</p>

                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="8"
                                cy="8"
                                r="8"
                                fill={
                                  (details?.status === "red" && "#FD1E1E") ||
                                  (details?.status === "yellow" && "#FFB200") ||
                                  (details?.status === "green" && "#0AB34E")
                                }
                              />
                            </svg>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <BottomNav />
    </section>
  );
}

export default InspectionSingleReport;
